module.exports = __webpack_public_path__ + "img/stock0.de6d572d.png";